/**
 * Swazi lilangeni.
 */
export var SZL = {
  code: 'SZL',
  base: 10,
  exponent: 2
};